module.exports = __webpack_public_path__ + "img/Engie E&C_120X35.a9599236.png";